import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-dvh w-full absolute flex flex-col justify-center items-center text-center flex-1" }
const _hoisted_2 = {
  key: 0,
  class: "text-white font-semibold"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "relative inline-block" }
const _hoisted_5 = {
  key: 0,
  class: "bg-white text-zinc-950 p-1 rounded-lg absolute text-xs min-w-max -bottom-8 -left-1/2 -translate-x-1/2 -z-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_url_input = _resolveComponent("url-input")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("header", null, [
      _createElementVNode("h1", { class: "text-6xl text-matte-light-blue font-bold" }, "OUSH"),
      _createElementVNode("h2", { class: "text-xl text-zinc-600 font-semibold" }, "Open URL Shortener")
    ], -1)),
    _createElementVNode("section", null, [
      _createElementVNode("form", {
        class: "m-4",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.short && _ctx.short(...args)), ["prevent"]))
      }, [
        _createVNode(_component_url_input, {
          modelValue: _ctx.url,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.url) = $event)),
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 32),
      (_ctx.shortUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createTextVNode(" Short Url: ")),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("a", {
              href: _ctx.shortUrl,
              target: "_blank",
              class: "text-matte-light-blue hover:underline hover:text-white"
            }, _toDisplayString(_ctx.shortUrl), 9, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyUrl && _ctx.copyUrl(...args)))
              }, _cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fa-solid fa-copy ml-3 hover:text-matte-light-blue" }, null, -1)
              ])),
              _createVNode(_Transition, { name: "copied" }, {
                default: _withCtx(() => [
                  (_ctx.copied)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Copied to clipboard!"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}